"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
let [fs, dotenv] = [null, null];

let isModuleAvailable = moduleName => {
  try {
    require.resolve(moduleName);

    return true;
  } catch (e) {
    return false;
  }
};

try {
  let moduleName = ['fs', 'dotenv'];

  if (isModuleAvailable(moduleName[0])) {
    fs = require(moduleName[0]);
  }

  if (isModuleAvailable(moduleName[1])) {
    dotenv = require(moduleName[1]);
  }
} catch (e) {}

const env = process.env.STAGE ? process.env.STAGE.toUpperCase() : process.env.NODE_ENV ? process.env.NODE_ENV.toUpperCase() : null;
const envfile = env && fs && typeof fs.existsSync == "function" && fs.existsSync(`.env.${env.toLocaleLowerCase()}`) ? `.env.${env.toLocaleLowerCase()}` : '.env';
const environmentsVariables = { ...(fs && typeof fs.existsSync == "function" && fs.existsSync(envfile) ? dotenv.parse(fs.readFileSync(envfile)) : {})
};

if (env) {
  for (const param in environmentsVariables) {
    if (param.search(`${env}_`) >= 0) {
      environmentsVariables[param.replace(`${env}_`, '')] = environmentsVariables[param];
    }
  }
}

for (const e in process.env) {
  if (e.indexOf('ECS_') >= 0) {
    environmentsVariables[e.substr(4)] = process.env[e];
  }
}

var _default = environmentsVariables;
exports.default = _default;